<template>
    <akteure-aktiv />
</template>

<script>

    import AkteureAktiv from "../components/akteure/Akteure";

    export default {
        name: "Akteure",
        components: {AkteureAktiv},
        metaInfo: {
            title: "Akteure",
            meta: [
                {name: 'description', content: 'Aus welchen Akteuren besteht unser Verein'}
            ]
        }
    }
</script>